import { render, staticRenderFns } from "./LocationsStandalone.vue?vue&type=template&id=077705bf&scoped=true"
import script from "./LocationsStandalone.vue?vue&type=script&lang=js"
export * from "./LocationsStandalone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077705bf",
  null
  
)

export default component.exports